// Field helpers shared across Leads list/detail/forms.

export const SYSTEM_FIELD_META = {
  first_name: { defaultLabel: 'Nombre', type: 'text', defaultOrder: 1, defaultListVisible: true },
  last_name: { defaultLabel: 'Apellido', type: 'text', defaultOrder: 2, defaultListVisible: false },
  phone_e164: { defaultLabel: 'Teléfono', type: 'phone', defaultOrder: 3, defaultListVisible: true },
  email: { defaultLabel: 'Email', type: 'email', defaultOrder: 4, defaultListVisible: true },
  city: { defaultLabel: 'Ciudad', type: 'text', defaultOrder: 5, defaultListVisible: true },
  source: { defaultLabel: 'Origen', type: 'text', defaultOrder: 6, defaultListVisible: true },
  service: { defaultLabel: 'Servicio', type: 'text', defaultOrder: 7, defaultListVisible: false },
};

/**
 * Resolve the final config for a system field given tenant overrides.
 * Falls back to defaults if not overridden.
 */
export function resolveSysField(key, overrides) {
  const meta = SYSTEM_FIELD_META[key];
  if (!meta) return null;
  const o = (overrides && overrides[key]) || {};
  return {
    key,
    label: o.label?.trim() || meta.defaultLabel,
    placeholder: o.placeholder || '',
    type: meta.type,
    hidden: !!o.hidden,
    required: o.required ?? false,
    show_in_list: o.show_in_list ?? meta.defaultListVisible,
    order: o.order ?? meta.defaultOrder,
  };
}

export function listVisibleSystemFields(overrides) {
  return Object.keys(SYSTEM_FIELD_META)
    .map((k) => resolveSysField(k, overrides))
    .filter((f) => !f.hidden)
    .sort((a, b) => a.order - b.order);
}

export function listSystemFieldsInTable(overrides) {
  return Object.keys(SYSTEM_FIELD_META)
    .map((k) => resolveSysField(k, overrides))
    .filter((f) => !f.hidden && f.show_in_list)
    .sort((a, b) => a.order - b.order);
}

/**
 * Get value of a system field from a lead doc, formatted.
 */
export function getSysValue(lead, key) {
  return lead[key] ?? null;
}
